import React, { useEffect, useState } from "react";

import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  IconButton,
  Select,
  Divider,
} from "@chakra-ui/react";

import supplier_details_filies_side_by_side_mode_button_icon from "../../assets/images/icons/supplier_details_filies_side_by_side_mode_button_icon.png";
import SupplierChange from "../../views/SupplierDetail/components/SupplierChange";
import SupplierChangesSideBySide from "../../views/SupplierDetail/components/SupplierChangesSideBySide";

import FONT_STYLE_LIST from "../../constants/FontStylesListConstant";
import ThemeColorConstant from "constants/ThemeColorsConstant";

import dot_verticle_icon from "../../assets/images/icons/dots-vertical_icon.png";

import PdfComparisonComponent from "components/pdf/ComparePdf";
import { zoomPlugin } from "@react-pdf-viewer/zoom";

import "@react-pdf-viewer/page-navigation/lib/styles/index.css";
import "@react-pdf-viewer/zoom/lib/styles/index.css";

import { searchPlugin } from "@react-pdf-viewer/search";
import SearchPdf from "components/pdf/SearchPdf";
import Sync from "assets/images/icons/sync.svg";
import SyncFill from "assets/images/icons/syncFill.svg";

export default function FilesTabAccordionItem({
  file_name,
  file_changes_data,
  pageNumber,
  fileLink1,
  fileLink2,
  setFileUrl,
  onClickFn,
}) {
  const [sideBySideMode, setSideBySideMode] = useState(true);
  const [displayOldContent, setDisplayOldContent] = useState(0);
  const [displayNewContent, setDisplayNewContent] = useState(0);

  const [fontStyle, setFontStyle] = useState("Arial");
  const [fontSize, setFontSize] = useState("14px");

  const searchPluginInstance = searchPlugin();
  const { Search } = searchPluginInstance;
  const [syncScroll, setSyncScroll] = useState(true);
  const zoomPluginInstance = zoomPlugin();
  const { ZoomInButton, ZoomOutButton, ZoomPopover, CurrentScale } =
    zoomPluginInstance;
  const zoomPluginInstance2 = zoomPlugin();
  const { zoomTo } = zoomPluginInstance2;

  const handleSideBySideMode = (e) => {
    e.stopPropagation();
    setSideBySideMode(!sideBySideMode);
  };

  // useEffect
  useEffect(() => {
    setDisplayNewContent(sideBySideMode ? 1 : 0);
    setDisplayOldContent(sideBySideMode ? -1 : 0);
  }, [sideBySideMode]);

  function generateFontSizes(start, end, step) {
    const fontSizes = [];
    for (let size = start; size <= end; size += step) {
      fontSizes.push(size + "px");
      step += 2;
    }
    return fontSizes;
  }
  const handleScrollSync = (e) => {
    e.stopPropagation();

    setSyncScroll(!syncScroll);
  };

  const fileType = file_name?.split(".")[file_name?.split(".")?.length - 1].toUpperCase();

  return (
    <AccordionItem>
      {({ isExpanded }) => (
        <>
          <AccordionButton
            as="div"
            className="hover:cursor-pointer"
            onClick={() => {
              setFileUrl(fileLink1);
              onClickFn();
            }}
          >
            <div className="flex w-full ">
              <div
                className={` mx-2 -mr-1 flex-1 ${isExpanded ? "w-[33%]" : ""} `}
              >
                <div className="flex flex-row h-full">
                  <div className="my-auto">
                    <AccordionIcon />
                  </div>
                  <div className="flex flex-row justify-between w-full my-auto ml-2 truncate ">
                    {isExpanded ? (
                      <p>
                        <b> {file_name.split(".")[0]} </b>
                      </p>
                    ) : (
                      <h4 className="">{file_name.split(".")[0]}</h4>
                    )}
                  </div>
                </div>
              </div>
              {isExpanded && (
                <>
                  <div className="block md:hidden">
                    <IconButton
                      variant="ghost"
                      icon={<img src={dot_verticle_icon} />}
                      sx={{
                        width: "40px",
                        height: "40px",
                        justifyContent: "center",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                  <div
                    className="flex-row flex-1 hidden w-1/10 md:block "
                    onClick={(e) => e.stopPropagation()}
                  >
                    {fileType === "HTML" && (
                      <div className="flex flex-row justify-center gap-2 ">
                        <div className="w-[3.8rem] my-auto  ">
                          <Select
                            size="sm"
                            onChange={(e) => setFontSize(e.target.value)}
                            value={fontSize}
                          >
                            {generateFontSizes(10, 50, 2).map((size) => {
                              return <option value={size}>{size}</option>;
                            })}
                          </Select>
                        </div>
                        <div>
                          <Divider
                            sx={{
                              borderWidth: "1px", // change the width of the border
                              borderStyle: "solid", // change the style of the border
                              borderRadius: 0,
                              borderColor: ThemeColorConstant.hover_background,
                            }}
                            orientation="vertical"
                          />
                        </div>

                        <div className=" w-[12rem] my-auto   ">
                          <Select
                            name="font_style"
                            size="sm"
                            onChange={(e) => setFontStyle(e.target.value)}
                            value={fontStyle}
                          >
                            {FONT_STYLE_LIST.map((font) => {
                              return (
                                <option value={font.value}>{font.label}</option>
                              );
                            })}
                          </Select>
                        </div>

                        <div>
                          <Divider
                            sx={{
                              borderWidth: "1px", // change the width of the border
                              borderStyle: "solid", // change the style of the border
                              borderRadius: 0,
                              borderColor: ThemeColorConstant.hover_background,
                            }}
                            orientation="vertical"
                          />
                        </div>

                        <IconButton
                          variant={"ghost"}
                          icon={
                            <img
                              src={
                                supplier_details_filies_side_by_side_mode_button_icon
                              }
                            />
                          }
                          onClick={handleSideBySideMode}
                        />
                      </div>
                    )}
                  </div>
                  {fileType === "PDF" && (
                    <>
                      <div
                        className="flex items-center mx-3"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <div
                          className="flex items-center"
                          onClick={handleScrollSync}
                        >
                          <img
                            src={syncScroll ? SyncFill : Sync}
                            className="w-8"
                            alt=""
                          />
                          <span className={`${syncScroll && "text-red-500"}`}>
                            Sync Scroll
                          </span>
                        </div>
                      </div>

                      <div
                        className="flex flex-row items-center flex-1 w-2/5 "
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Search>
                          {(renderSearchProps) => (
                            <SearchPdf {...renderSearchProps} />
                          )}
                        </Search>
                        <div className="flex flex-row justify-center pr-20">
                          <div style={{ padding: "0px 2px" }}>
                            <ZoomInButton />
                          </div>
                          <div style={{ padding: "0px 2px" }}>
                            <ZoomOutButton />
                          </div>
                          <div style={{ padding: "0px 2px" }}>
                            <ZoomPopover />
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </AccordionButton>

          <AccordionPanel>
            {fileType === "PDF" ? (
              <div className="flex flex-row w-full border primary-border-color ">
                <PdfComparisonComponent
                  searchPluginInstance={searchPluginInstance}
                  zoomPluginInstance={zoomPluginInstance}
                  zoomPluginInstance2={zoomPluginInstance2}
                  syncScroll={syncScroll}
                  pageNumber={pageNumber}
                  file1={fileLink1}
                  file2={fileLink2}
                />
                <CurrentScale>
                  {(props) => {
                    zoomTo(props.scale);
                  }}
                </CurrentScale>
              </div>
            ) : (
              <div className="flex flex-row w-full border primary-border-color ">
                <div className={sideBySideMode ? "w-full" : "w-full"}>
                  {sideBySideMode ? (
                    <SupplierChangesSideBySide
                      allChangesData={file_changes_data}
                      display_change_type={0}
                      font_style={fontStyle}
                      font_size={fontSize}
                    />
                  ) : (
                    <div>
                      {file_changes_data?.map((data, index) => {
                        return (
                          <SupplierChange
                            change_data={data}
                            display_change_type={0}
                            font_style={fontStyle}
                            font_size={fontSize}
                          />
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            )}
          </AccordionPanel>
        </>
      )}
    </AccordionItem>
  );
}
